<template>
    <div
        :class="cssClasses"
        :style="{
            margin: '1rem',
            position: 'relative',
            width: `${width}`,
            height: `${height}`,
            ...styles
        }"
    >
        <canvas :id="chartId"></canvas>
    </div>
</template>

<script>
import { Chart, registerables } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import annotationPlugin from 'chartjs-plugin-annotation';
//import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(
    ...registerables,
    zoomPlugin,
    annotationPlugin /*, ChartDataLabels*/
);

export default {
    name: 'MixedChart',
    props: {
        chartId: {
            type: String,
            default: 'mixedChart'
        },
        width: {
            type: String,
            default: 'auto'
        },
        height: {
            type: String,
            default: '400px'
        },
        cssClasses: {
            type: String,
            default: ''
        },
        styles: {
            type: Object,
            default: () => ({})
        },
        plugins: {
            type: Array,
            default: () => []
        },
        chartData: {
            type: Object,
            required: true
        },
        chartOptions: {
            type: Object,
            default: () => ({
                responsive: true,
                maintainAspectRatio: true, // Adjust as needed
                interaction: {
                    mode: 'x'
                },
                scales: {
                    y: {
                        beginAtZero: true
                    }
                },
                plugins: {
                    zoom: {
                        zoom: {
                            wheel: {
                                enabled: true
                            }
                        },
                        pan: {
                            enabled: true,
                            mode: 'xy'
                        },
                        limits: {
                            y: { min: 0, max: 200000 }
                        }
                    }
                }
            })
        }
    },
    watch: {
        chartData() {
            this.renderChart();
        }
    },
    mounted() {
        this.renderChart();
    },
    methods: {
        renderChart() {
            if (this.chart) {
                this.chart.destroy(); // Destroy previous chart instance to prevent memory leaks
            }

            const ctx = document.getElementById(this.chartId).getContext('2d');
            this.chart = new Chart(ctx, {
                data: this.chartData,
                options: this.chartOptions,
                plugins: this.plugins
            });
        }
    }
};
</script>

<style scoped>
/* Ensure the canvas does not expand beyond its container */
</style>
